import { api } from "@/api/api";

export const fetcher = (url) =>
  fetch(process.env.NEXT_PUBLIC_BASE_API + url).then((res) => res.json());

export function numberWithCommas(x) {
  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return parts.join(".");
}

export default async function getServer(context) {
  const {
    RoutingId,
    RoutingController,
    RoutingAction,
    Page,
    RoutingTypeId,
    ...queries
  } = context.query;

  const routingUrl =
    api +
    "/Routing?RoutingId=" +
    RoutingId +
    (Page !== "undefined" ? "&page=" + Page : "") +
    "&" +
    new URLSearchParams(queries).toString();

  // Parallel fetches
  const [resData, resHeader, resFooter] = await Promise.all([
    fetch(routingUrl, { next: { revalidate: 10 } }),
    fetch(api + "/header", { next: { revalidate: 10 } }),
    fetch(api + "/FooterMenu", { next: { revalidate: 10 } }),
  ]);

  const [data, dataHeader, dataFooter] = await Promise.all([
    resData.json(),
    resHeader.json(),
    resFooter.json(),
  ]);

  return {
    props: {
      data,
      dataHeader,
      dataFooter,
      RoutingController,
      RoutingAction,
      RoutingTypeId,
    },
  };
}
